import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=bbea9868&scoped=true&"
import script from "./CategoryDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=bbea9868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbea9868",
  null
  
)

export default component.exports